import { useContext } from "react";
import { AppContext } from "../App";
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiInstagram, FiLinkedin } from "react-icons/fi";

import logoImg from '../assets/logo.png'; // MWADEO logo asset

export default function Footer(props) {
    const appContext = useContext(AppContext);

    const currentYear = new Date().getFullYear();

    return (
        <footer className="kukaja-footer-wrapper">
            {/* Upper Section: Core Vital Info only (surfaceColor bg) */}
            <div className="footer-upper-section">
                <div className="container">
                    <div className="row g-4 justify-content-between align-items-start">
                        
                        {/* Column 1: Identity & Socials */}
                        <div className="col-12 col-md-4 footer-brand-column">
                            <div className="footer-logo-box mb-3" onClick={() => appContext.navTo({ item: 'home' })}>
                                <img src={logoImg} alt="MWADEO Logo" className="footer-logo" />
                                <span className="title-font-bold footer-brand-name">MWADEO</span>
                            </div>
                            <p className="font-regular footer-micro-desc mb-3">
                                Mwananchi Development Organization (MWADEO) is a non-governmental organization dedicated to lifting standards of living, modernizing agriculture, and promoting education and climate resilience across Tanzania.
                            </p>
                            <div className="footer-social-row d-flex gap-2">
                                <a href="#" className="footer-social-link" aria-label="Facebook"><FiFacebook size={16} /></a>
                                <a href="#" className="footer-social-link" aria-label="Instagram"><FiInstagram size={16} /></a>
                                <a href="#" className="footer-social-link" aria-label="LinkedIn"><FiLinkedin size={16} /></a>
                            </div>
                        </div>

                        {/* Column 2: Quick Minimal Navigation Links */}
                        <div className="col-6 col-md-3">
                            <h5 className="title-font-bold footer-col-title text-uppercase mb-3">
                                {"Quick Links"}
                            </h5>
                            <ul className="list-unstyled footer-links-list d-flex flex-column gap-2 font-regular">
                                <li onClick={() => appContext.navTo({ item: 'home' })}>
                                    {"Home"}
                                </li>
                                <li onClick={() => appContext.navTo({ item: 'about_us' })}>
                                    {"About Us"}
                                </li>
                                <li onClick={() => appContext.navTo({ item: 'services' })}>
                                    {"Services"}
                                </li>
                                <li onClick={() => appContext.navTo({ item: 'membership' })}>
                                    {"Membership"}
                                </li>
                                <li onClick={() => appContext.navTo({ item: 'contact_us' })}>
                                    {"Contact Us"}
                                </li>
                                <li> <a style={{textDecoration: "none", color: "inherit"}} href='https://nis.jamii.go.tz/auth/login' rel='noopeneer noreferrer' target='_blank'>
                                    {'NGOs Information System'}
                                    </a>
                                </li>
                                <li> <a style={{textDecoration: "none", color: "inherit"}} href='https://srv1.wazohost.net:2096/cpsess6175383474/3rdparty/roundcube/?_task=mail&_mbox=INBOX' rel='noopeneer noreferrer' target='_blank'>
                                    {'Staff Mail'}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        {/* Column 3: Quick Direct Contact Details */}
                        <div className="col-12 col-md-4">
                            <h5 className="title-font-bold footer-col-title text-uppercase mb-3">
                                {"Contact Info"}
                            </h5>
                            <div className="d-flex flex-column gap-3 font-regular footer-contact-info">
                                <div className="d-flex align-items-start gap-2">
                                    <FiMapPin size={16} className="mt-1 text-primary-color-fallback" />
                                    <span>Msasani Ward, Kinondoni District, Dar es Salaam, Tanzania (P. O. Box 106264)</span>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <FiPhone size={16} className="text-primary-color-fallback" />
                                    <div className="d-flex flex-column gap-1">
                                    <span>+255 784 767 933</span>
                                    <span>+255 766 430 125</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-2">
                                    <FiMail size={16} className="text-primary-color-fallback" />
                                    <span>info@mwadeo.co.tz</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Lower Section: Thin Copyright Ribbon (primaryColor bg) */}
            <div className="footer-lower-ribbon">
                <div className="container">
                    <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-2 font-regular text-white-75 row-gap-sm">
                        <div>
                            <span>© {currentYear} MWADEO. All Rights Reserved.</span>
                        </div>
                        {/* <div className="crafted-by-credits">
                            <span>Website crafted by <a className="werenium" target="_blank" rel="noopener noreferrer" href="https://werenium.com">WERENIUM</a></span>
                        </div> */}
                    </div>
                </div>
            </div>
        </footer>
    );
}